import SubscriptionService from "@/services/SubscriptionService";

export const getAccountSubscriptions = async ({ commit }, accountId) => {
  const subscriptionList = await SubscriptionService.getAccountSubscriptions(
    accountId
  );

  commit("setAccountSubscriptions", subscriptionList);

  return subscriptionList;
};

export const fetchAccountPlans = async ({ commit }, { accountId, useCurrencyOptions = false }) => {
  const plans = await SubscriptionService.getAccountPlans(accountId, useCurrencyOptions);

  commit("setAccountPlans", plans);
};

export const updateAccountSubscriptionMultiItem = async ({ commit }, { accountId, payload }) => {
  const response = await SubscriptionService.updateAccountSubscriptionMultiItem(
    accountId,
    payload
  );

  if (!response.paymentIntentClientSecret) {
    const subscriptionList = await SubscriptionService.getAccountSubscriptions(accountId);
    commit("setAccountSubscriptions", subscriptionList);
  }

  return response;
};

const TRIAL_END_POLL_INTERVAL_MS = 2000;
const TRIAL_END_POLL_TIMEOUT_MS = 30000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// A trial upgraded to paid on the same price is ended by the backend through the Stripe API, but the
// backend's subscription record only changes when Stripe's webhook lands. Re-fetch until the subscription
// stops being "trialing" (active, or past_due / incomplete when the charge failed), then refresh the plan
// state that depends on it. Gives up quietly after the timeout: the plans page still re-fetches when its
// tab becomes visible again. Commits only while the same account is open, since resetAccount empties
// this module on an account switch.
export const refreshUntilTrialEnds = async ({ commit, dispatch, rootGetters }, { accountId, subscriptionId }) => {
  const sameAccount = () => rootGetters["Account/accountKey"] === accountId;
  const deadline = Date.now() + TRIAL_END_POLL_TIMEOUT_MS;

  while (Date.now() < deadline) {
    await sleep(TRIAL_END_POLL_INTERVAL_MS);

    let subscriptionList;
    try {
      subscriptionList = await SubscriptionService.getAccountSubscriptions(accountId);
    } catch (e) {
      continue;
    }

    if (!sameAccount()) {
      return;
    }

    commit("setAccountSubscriptions", subscriptionList);

    const subscription = (subscriptionList || []).find(({ id }) => id === subscriptionId);
    if (subscription?.status !== "trialing") {
      break;
    }
  }

  if (!sameAccount()) {
    return;
  }

  await Promise.allSettled([
    dispatch("fetchAccountPlans", { accountId }),
    dispatch("Subscription/fetchAccountPlanFeatures", accountId, { root: true }),
  ]);
};
